// Central place for brand-level constants.

// Delivery inbox for lead notifications (used server-side by lib/email.ts).
export const CONTACT_EMAIL = "connect@carrot-on.horse";

// The founders' public, on-domain contacts shown on the site.
export const REGINA_EMAIL = "regina@carrot-on.horse";
export const VADIM_EMAIL = "vadim@carrot-on.horse";

export const MAILTO = `mailto:${REGINA_EMAIL}?subject=${encodeURIComponent(
  "CarrotOnTheHorse: let's talk",
)}&body=${encodeURIComponent(
  "Hi, I came across CarrotOnTheHorse and I'd love to hear more.\n\n",
)}`;

// The brand tagline. Render it in the serif (Cambria) italic treatment.
export const TAGLINE = "We don't replace the horseman, we multiply them";

// The product app. Login + signup live there; the marketing site only links out.
export const APP_URL = "https://app.carrot-on.horse";
export const LOGIN_URL = `${APP_URL}/login`;
export const SIGNUP_URL = `${APP_URL}/register`;
